import axios from 'axios'
import { getApiUrls } from "@/http/base.http";

export function getDeviceStatus() {
    const { env } = getApiUrls();
    return axios.get(`${env}dashboard/device/status/get`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddDeviceGraph(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}dropdown/device/ref/dd`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getDeviceGraphData(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}dashboard/device/graph/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

    export function getSensorDetailData() {
    const { env } = getApiUrls();
    return axios.get(`${env}dashboard/sensor/current/value`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function getFlowMgmtData(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}dashboard/flow/management`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddTagNumber(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}dropdown/physicalid/dd`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
